export default __webpack_public_path__ + "static/image-stats-card-610011fcfd7aaaa2b40e80f3d7494f85.png";